<script lang="ts">
  import { Col, Table, Progress, Image } from "sveltestrap";
  import Card from "../../Core/Card.svelte";
  import Employeecart from "../../../Data/ComponentData/WidgetData/Genral/EmployeeCart.json";
  let imgPath : string= '/assets/images/user';
  import { EMPLOYEESTATUS } from "../../../utils/Constant/Constant";
</script>

<Col xl="6" class="xl-100 box-col-12">
  <Card
    cardProps="employee-status"
    cardHeaderprops="pb-0 d-flex justify-content-between align-items-center"
    headerTitle={EMPLOYEESTATUS}
  >
    <div slot="contentbody">
      <div class="user-status table-responsive  ">
        <Table class="table table-bordernone">
          <thead>
            <tr>
              {#each Employeecart.employeeheader as header}
                <th scope="col">{header.title}</th>
              {/each}
            </tr>
          </thead>
          <tbody>
            {#each Employeecart.Employeecartdata as userItem}
              <tr>
                <td class="bd-t-none u-s-tb">
                  <div class="align-middle image-sm-size">
                    <Image
                      class="img-radius align-top m-r-15 rounded-circle"
                      src={`${imgPath}/${userItem.src}`}
                      alt=""
                    />
                    <div class="d-inline-block">
                      <h6>
                        {userItem.name}<span class="text-muted">{userItem.online}</span>
                      </h6>
                    </div>
                  </div>
                </td>
                <td>{userItem.Designation}</td>
                <td>
                  <div class="progress-showcase">
                    <Progress
                      color={userItem.color}
                      style="height: 8px;"
                      value={userItem.width}
                    />
                  </div>
                </td>
                <td>{userItem.Experience}</td>
              </tr>
            {/each}
          </tbody>
        </Table>
      </div>
    </div>
  </Card>
</Col>
